import React, { useState } from "react";
import { toast } from "sonner";
import { Download } from "lucide-react";
import { MOCK_ORDERS } from "../../data/mock";
import { StatusBadge } from "../customer/CustomerHome";

const TABS = ["All", "New", "In production", "Ready", "Delivered"];

export default function VendorOrders() {
  const [tab, setTab] = useState("All");
  const rows = MOCK_ORDERS.filter((o) => {
    if (tab === "All") return true;
    if (tab === "New") return o.status === "placed";
    if (tab === "In production") return o.status === "printing";
    if (tab === "Ready") return o.status === "ready";
    if (tab === "Delivered") return o.status === "delivered";
    return true;
  });

  return (
    <div data-testid="vendor-orders">
      <h1 className="font-display text-3xl font-bold">Orders</h1>
      <div className="mt-3 flex flex-wrap gap-2">
        {TABS.map((t) => (
          <button key={t} onClick={() => setTab(t)} className={`rounded-full border px-3 py-1 text-xs font-semibold ${tab === t ? "border-neutral-900 bg-neutral-950 text-white" : "border-neutral-200 hover:border-neutral-900"}`} data-testid={`vo-tab-${t.toLowerCase().replace(/\s+/g, "-")}`}>{t}</button>
        ))}
      </div>

      <div className="mt-4 overflow-hidden rounded-lg border border-neutral-200 bg-white">
        <table className="w-full text-sm">
          <thead className="border-b border-neutral-200 bg-neutral-50 text-xs uppercase tracking-widest text-neutral-500">
            <tr>
              <th className="px-4 py-3 text-left">Order</th>
              <th className="px-4 py-3 text-left">Customer</th>
              <th className="px-4 py-3 text-left">Amount</th>
              <th className="px-4 py-3 text-left">Status</th>
              <th className="px-4 py-3 text-right">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-neutral-100">
            {rows.map((o) => (
              <tr key={o.id} className="hover:bg-neutral-50" data-testid={`vo-row-${o.id}`}>
                <td className="px-4 py-3">
                  <div className="font-mono text-xs text-neutral-500">{o.id}</div>
                  <div className="font-semibold">{o.product}</div>
                </td>
                <td className="px-4 py-3">
                  <div>{o.customer}</div>
                  <div className="text-xs text-neutral-500">{o.location}</div>
                </td>
                <td className="px-4 py-3 font-mono">₹{o.amount.toLocaleString("en-IN")}</td>
                <td className="px-4 py-3"><StatusBadge status={o.status} /></td>
                <td className="px-4 py-3 text-right">
                  <div className="flex justify-end gap-2">
                    <button onClick={() => toast.success("Marked ready")} className="rounded-md border border-neutral-300 px-2 py-1 text-xs font-semibold hover:border-neutral-900" data-testid={`vo-ready-${o.id}`}>Mark ready</button>
                    <button onClick={() => toast.success("File downloaded")} className="inline-flex items-center gap-1 rounded-md border border-neutral-300 px-2 py-1 text-xs font-semibold hover:border-neutral-900" data-testid={`vo-file-${o.id}`}><Download size={12} /> File</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
